import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { CoopServiceService } from '../../../services/Coop/coop-service.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";

import Swal from 'sweetalert2';

import { isPlatformBrowser } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import he from '@angular/common/locales/he';
declare var google: any;
declare var jQuery: any;

import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_data_countries2 from "@amcharts/amcharts4-geodata/data/countries2";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

@Component({
  selector: 'app-coop',
  templateUrl: './coop.component.html',
  styleUrls: ['./coop.component.scss']
})
export class CoopComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId, private zone: NgZone,

    private CoopServiceService: CoopServiceService,
    private SpinnerService: NgxSpinnerService,
    private router: Router,
  ) { }

  listCoop: any;
  coopId: any;
  PhakId: any;
  KhetId: any;
  phak: any;
  phak_1: any;
  phak_2: any;
  phak_3: any;
  phak_4: any;
  KhetList: any;
  province_: any;
  province_s: any;
  PhakList: any;
  khet: any;
  groupkhet_bkk1: any;
  groupkhet_bkk2: any;
  groupkhet_1: any;
  groupkhet_2: any;
  groupkhet_3: any;
  groupkhet_4: any;
  groupkhet_5: any;
  groupkhet_6: any;
  groupkhet_7: any;
  groupkhet_8: any;
  groupkhet_9: any;
  groupkhet_10: any;
  groupkhet_11: any;
  groupkhet_12: any;
  groupkhet_13: any;
  groupkhet_14: any;
  groupkhet_15: any;
  groupkhet_16: any;
  groupkhet_17: any;
  groupkhet_18: any;
  orgid: any;
  phakName: any;
  checkkhet: any = [];
  KhetList_: any;
  KhetId_: any;
  ProvinceByKhet: any;
  year_now: any;
  datayear: any;
  searchText: any;
  sumResult: any;
  xValues: any;
  SumCoop: any[] = [];
  maxXObject: any;
  minValues: any;
  minXObject: any;
  provinceNameSort: any;
  CoopStatusProvinceYearOne: any;
  selectProviceSearch: any;
  CoopStatusProvinceYearBySearch: any;
  sumResult_: any;
  provinceName: any;

  ngOnInit(): void {
    this.year_now = ((new Date()).getFullYear() - 1) + 543;
    this.datayear = this.year_now;
    this.GetPhakList();
    this.GetKhetList();
    this.selectProviceSearch = false;



    this.SpinnerService.show();
    this.listCoop = null;
    this.sumResult_ = 0;
    this.PhakId = "null";
    this.KhetId = "null";
    this.orgid = sessionStorage.getItem('orgid');
    this.provinceName = sessionStorage.getItem('provinceName');

    this.CoopServiceService.GetCoopStatusProvinceYearBySearch(this.orgid, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopStatusProvinceYearBySearch = res;

      for (let i = 0; i < res.length; i++) {
        this.sumResult = res.length;
        this.CoopStatusProvinceYearOne = res;
        if (res[i].provinceName == this.provinceNameSort) {

        }
      }
      this.SpinnerService.hide();
    });

  }

  setphak(event) {
    this.PhakId = event;
    this.KhetId = "null";
    this.orgid = "null";

    this.CoopServiceService.GetPhakList().subscribe(res => {
      for (let i = 0; i < res.length; i++) {

        if (this.PhakId == res[i].phakId) {

          this.phakName = res[i].phakName;

        }
      }

    });

    this.GetKhetList();

  }

  setkhet(event) {
    this.KhetId = event;
    this.KhetId_ = this.KhetId;
    this.PhakId = "null";
    this.orgid = "null";
    this.GetProvinceByKhet();

  }

  setProvince(event) {
    this.orgid = event;
    this.KhetId = "null";
    this.PhakId = "null";
  }

  GetPhakList() {
    this.CoopServiceService.GetPhakList().subscribe(res => {
      this.PhakList = res;
    });
  }

  GetKhetList() {
    this.CoopServiceService.GetKhetList().subscribe(res => {
      this.checkkhet = res;

      for (let i = 0; i < res.length; i++) {

        if (this.PhakId == 1) {
          this.groupkhet_bkk1 = 'true';
          this.groupkhet_bkk2 = 'true';
          this.checkkhet = [
            { "khet_desc": res[18].khet_desc, "khet_id": res[18].khet_id },
            { "khet_desc": res[19].khet_desc, "khet_id": res[19].khet_id },
          ]
        }
        else if (this.PhakId == 2) {
          this.groupkhet_1 = 'true';
          this.checkkhet = [
            { "khet_desc": res[14].khet_desc, "khet_id": res[14].khet_id },
            { "khet_desc": res[15].khet_desc, "khet_id": res[15].khet_id },
            { "khet_desc": res[16].khet_desc, "khet_id": res[16].khet_id },
            { "khet_desc": res[17].khet_desc, "khet_id": res[17].khet_id },
          ]
        }
        else if (this.PhakId == 3) {
          this.checkkhet = [
            { "khet_desc": res[0].khet_desc, "khet_id": res[0].khet_id },
            { "khet_desc": res[1].khet_desc, "khet_id": res[1].khet_id },
            { "khet_desc": res[2].khet_desc, "khet_id": res[2].khet_id },
            { "khet_desc": res[3].khet_desc, "khet_id": res[3].khet_id },
            { "khet_desc": res[7].khet_desc, "khet_id": res[7].khet_id },
            { "khet_desc": res[8].khet_desc, "khet_id": res[8].khet_id },
          ]
        }
        else if (this.PhakId == 4) {
          this.checkkhet = [
            { "khet_desc": res[9].khet_desc, "khet_id": res[9].khet_id },
            { "khet_desc": res[10].khet_desc, "khet_id": res[10].khet_id },
            { "khet_desc": res[11].khet_desc, "khet_id": res[11].khet_id },
            { "khet_desc": res[12].khet_desc, "khet_id": res[12].khet_id },
            { "khet_desc": res[13].khet_desc, "khet_id": res[13].khet_id },
          ]
        }
        else if (this.PhakId == 5) {
          this.checkkhet = [
            { "khet_desc": res[4].khet_desc, "khet_id": res[4].khet_id },
            { "khet_desc": res[5].khet_desc, "khet_id": res[5].khet_id },
            { "khet_desc": res[6].khet_desc, "khet_id": res[6].khet_id }
          ]
        }
      }

    });
  }

  GetProvinceByKhet() {
    this.CoopServiceService.GetProvinceByKhet(this.KhetId_).subscribe(res => {
      this.ProvinceByKhet = res;
    });
  }

  Search() {

    this.SpinnerService.show();
    this.listCoop = null;
    this.sumResult_ = 0;
    if (this.PhakId != undefined && this.KhetId != undefined && this.orgid != undefined) {
      this.CoopServiceService.GetCoopStatusProvinceYearBySearch(this.orgid, this.PhakId, this.KhetId).subscribe(res => {

        this.CoopStatusProvinceYearBySearch = res;
        for (let i = 0; i < res.length; i++) {
          this.sumResult = res.length;
          this.CoopStatusProvinceYearOne = res;
          if (res[i].provinceName == this.provinceNameSort) {

          }
        }
        this.SpinnerService.hide();

      });
    } else {
      Swal.fire('Warnning', 'กรุณาเลือกข้อมูลที่ต้องการค้นหา', 'warning');
      this.SpinnerService.hide();
    }

  }

  selectProvice_Search() {
    this.selectProviceSearch = true;

    this.SpinnerService.show();

    if (this.PhakId != undefined && this.KhetId != undefined && this.orgid != undefined) {
      this.CoopServiceService.GetCoopList(this.orgid, this.PhakId, this.KhetId).subscribe(res => {
        this.listCoop = res;
        this.SpinnerService.hide();


        for (let i = 0; i < res.length; i++) {
          this.sumResult_ = res.length;
        }

      });

    } else {
      Swal.fire('Warnning', 'กรุณาเลือกข้อมูลที่ต้องการค้นหา', 'warning');
      this.SpinnerService.hide();
    }
  }

  selectCoopProfile(event) {
    this.coopId = event;
    sessionStorage.setItem('coopId', this.coopId);
    this.router.navigate(["/ProfileCoop"]);
  }

  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  ngAfterViewInit(): void {

    this.browserOnly(() => {

      this.CoopServiceService.GetCoopStatusProvinceYearOne(this.datayear).subscribe(res => {

        for (let i = 0; i < res.length; i++) {
          this.SumCoop.push(res[i].sum);
        }

        // max
        this.xValues = this.SumCoop.map(function (o) { return o; });

        this.xValues = Array.from(this.SumCoop, o => o);


        var xMax = Math.max.apply(null, this.xValues);

        xMax = Math.max(...this.xValues);

        var maxXObjects = this.SumCoop.filter(function (o) { return o === xMax; });

        xMax = Math.max.apply(null, this.SumCoop.map(function (o) { return o; }));
        this.maxXObject = this.SumCoop.filter(function (o) { return o === xMax; })[0];

        xMax = Math.max(...Array.from(this.SumCoop, o => o));
        this.maxXObject = this.SumCoop.find(o => o === xMax);

        // min
        this.minValues = this.SumCoop.map(function (o) { return o; });

        this.minValues = Array.from(this.SumCoop, o => o);


        var xMin = Math.min.apply(null, this.minValues);

        xMin = Math.min(...this.minValues);

        var minXObjects = this.SumCoop.filter(function (o) { return o === xMin; });

        xMin = Math.min.apply(null, this.SumCoop.map(function (o) { return o; }));
        this.minXObject = this.SumCoop.filter(function (o) { return o === xMin; })[0];

        xMin = Math.min(...Array.from(this.SumCoop, o => o));
        this.minXObject = this.SumCoop.find(o => o === xMin);


      });

    });

  }
}
